export default __webpack_public_path__ + "static/media/Elec10.412dd31f.png";